var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1800,
    height: 1800,
    viewBox: "0 0 1350 1350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 136, 133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 349)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 1 380 L 1 0 L 351 0 L 351 380 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 351, 734)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 0 1 L 376 1 L 376 350 L 0 350 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 354)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 1 381 L 1 0 L 351 0 L 351 381 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 351, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 0 0 L 376 0 L 376 349 L 0 349 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 726, 354)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 1 381 L 1 0 L 351 0 L 351 381 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.338c95cc17b2fe9e6945bd9fed709bd1.svg";
export { ForwardRef as ReactComponent };